module.exports = __webpack_public_path__ + "img/telegram_back.b90b60af.png";